import { render, staticRenderFns } from "./DataFormScrool.vue?vue&type=template&id=548a39eb&scoped=true&"
import script from "./DataFormScrool.vue?vue&type=script&lang=js&"
export * from "./DataFormScrool.vue?vue&type=script&lang=js&"
import style0 from "./DataFormScrool.vue?vue&type=style&index=0&id=548a39eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548a39eb",
  null
  
)

export default component.exports